import { render, staticRenderFns } from "./NoDataTip.vue?vue&type=template&id=67d18eea"
import script from "./NoDataTip.vue?vue&type=script&lang=js"
export * from "./NoDataTip.vue?vue&type=script&lang=js"
import style0 from "./NoDataTip.vue?vue&type=style&index=0&id=67d18eea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports